export default {
  ALL_ADMISSIONS: 'All Admissions',
  GRANT: 'Grant',
  ALWAYS_GRANT: 'Always Grant',
  ALWAYS_DENY: 'Always Deny',
};
